import script from "./ItemDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./ItemDetails.vue?vue&type=script&setup=true&lang=js"

import "./ItemDetails.vue?vue&type=style&index=0&id=08321b52&scoped=true&lang=postcss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08321b52"]])

export default __exports__